import { DatePicker, Form, Input, Modal } from "antd";
import { useState } from "react";
import { IProductionProjectPhaseMilestone } from "../../models/Production";

interface IModalAddMilestoneProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: (
    milestone: Omit<
      IProductionProjectPhaseMilestone,
      "id" | "prdProjectPhaseId"
    >,
  ) => void;
  phaseId: number;
}

const ModalAddProductionProjectPhaseMilestone = ({
  open,
  onCancel,
  onSubmit,
}: IModalAddMilestoneProps) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      const milestone: Omit<
        IProductionProjectPhaseMilestone,
        "id" | "prdProjectPhaseId"
      > = {
        milestoneName: values.milestoneName,
        targetDate: values.targetDate.toDate(),
        isCompleted: false,
        completedDate: null as any,
      };

      onSubmit(milestone);
      form.resetFields();
      onCancel();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Thêm cột mốc mới"
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Thêm"
      cancelText="Hủy"
      width={600}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Tên cột mốc"
          name="milestoneName"
          rules={[{ required: true, message: "Vui lòng nhập tên cột mốc" }]}
        >
          <Input placeholder="Nhập tên cột mốc" />
        </Form.Item>

        <Form.Item
          label="Ngày mục tiêu"
          name="targetDate"
          rules={[{ required: true, message: "Vui lòng chọn ngày mục tiêu" }]}
        >
          <DatePicker
            style={{ width: "100%" }}
            format="DD-MM-YYYY"
            placeholder="Chọn ngày mục tiêu"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAddProductionProjectPhaseMilestone;
